// extracted by mini-css-extract-plugin
export default {"title-card":"TitleCard_title-card__Yt0Tx","sub-title-card":"TitleCard_sub-title-card__z1Qrd"};